import { FC, Ref } from "react";
import { Segmented, SegmentedProps } from "antd";
import { clsx } from "clsx";
import classes from "./GenericSegmented.module.less";

interface GenericSegmentedProps extends Omit<SegmentedProps, "ref"> {
    ref?: Ref<HTMLDivElement>;
}

export const GenericSegmented: FC<GenericSegmentedProps> = ({ className, ...props }) => {
    const _className = clsx(classes.segmented, className);
    return <Segmented {...props} className={_className} />;
};
